module.exports = __webpack_public_path__ + "static/media/telaagroreceita.723174c1.svg";